const Constants = {
  TOKEN_KEY: "token",
  USER: "user",
  hashTokenKey: "hashToken",
  returnUrlKey: "returnUrl",
};

const Messages = {
  UnknownError: "An unknown error has occured",
  SessionExpired: "Your session has expired, please login again.",
  BankValidatingError: "Error in validating the bank account",
  NoRecord: "No record found!",
  ReduKyc:
    "Are you sure about this? If you start this process you will not be able to access or make any investments until you finish the KYC process again! If you quit you will have to submit another support request for redoing the KYC.",
};
const ButtonTitles = {
  AddButtonText: "Add",
  CancelButtonText: "Cancel",
  RetryButtonText: "Retry",
  AddBank: "Add bank account",
};
const Links = {
  TermsAndConditions: "https://www.acru.in/termsandcondition",
  PrivacyAndPolicy: "https://www.acru.in/privacy",
  CancellationAndRefundPlicy: "https://www.acru.in/cancelation",
  AboutUS: "https://www.acru.in/about",
};

const spalshItems = [
  {
    id: 1,
    image: process.env.REACT_APP_FIRST_SPLASH,
    title: "Smart Investments Made Easy ",
    description:
      "Invest in mutual funds and digital gold/silver for financial growth",
  },
  {
    id: 2,
    image: process.env.REACT_APP_THIRD_SPLASH,
    title: "Keep growing your wealth",
    description: "Regular investments pave the way for long term wealth",
  },
  {
    id: 3,
    image: process.env.REACT_APP_SECOND_SPLASH,
    title: "Celebrate joyfully,gift smartly",
    description: "Start gifting digital gold and silver to your loved ones",
  },
];
const dashboardCoursalItems = [
  {
    id: 0,
    type: "mutual",
    bgColor: process.env.REACT_APP_BUTTON_GRADIENT_COLOR,
    startText: "Invest in your future with the stability and potential of ",
    middleText: "mutual funds",
    endText: " ",
    leftImage:
      "https://acru-asset.s3.us-east-1.amazonaws.com/assets/banner1Left.svg",
    rightImage:
      "https://acru-asset.s3.us-east-1.amazonaws.com/assets/banner1Right.svg",
    buttonText: "Explore Now",
    buttonColor: "#E09A09",
    textColor: "#ffffff",
    middleTextColor: "#ffffff",
  },
  {
    id: 1,
    type: "goal",
    bgColor: "linear-gradient(276.31deg, #4BC59E 4.37%, #18519D 97.42%)",
    startText: "",
    middleText: "Save Now Buy Later",
    endText: "Set your Goals and Start saving for the future",
    leftImage:
      "https://acru-asset.s3.us-east-1.amazonaws.com/assets/banner4Left.svg",
    rightImage:
      "https://acru-asset.s3.us-east-1.amazonaws.com/assets/banner4Right.svg",
    buttonText: "Invest Now",
    buttonColor: process.env.REACT_APP_BUTTON_GRADIENT_COLOR,
    textColor: "#ffffff",
    middleTextColor: "#ffffff",
  },
  {
    id: 2,
    type: "silver",
    bgColor:
      "linear-gradient(180deg, #eae7e7 21.35%, #f2f2f1 53.65%,#eae7e7 100%)",
    startText: "Dazzle your investment portfolio with the ",
    middleText: "brilliance of Silver",
    endText: "",
    leftImage:
      "https://acru-asset.s3.us-east-1.amazonaws.com/assets/banner2Left.svg",
    rightImage:
      "https://acru-asset.s3.us-east-1.amazonaws.com/assets/banner2Right.svg",
    buttonText: "Invest Now",
    buttonColor: process.env.REACT_APP_BUTTON_GRADIENT_COLOR,
    textColor: "#000000",
    middleTextColor: "#E09A09",
  },
  {
    id: 3,
    type: "gold",
    bgColor:
      "linear-gradient(180deg, #8966B6 -20.63%, #293AB5 -20.61%, #0082C8 21.1%, #0082C8 73.27%, #667DB6 117.5%)",
    startText: "Experience the security and stability of ",
    middleText: "24K 999 pure gold investment",
    endText: "",
    leftImage:
      "https://acru-asset.s3.us-east-1.amazonaws.com/assets/banner3Left.svg",
    rightImage:
      "https://acru-asset.s3.us-east-1.amazonaws.com/assets/banner3Right.svg",
    buttonText: "Invest Now",
    buttonColor: process.env.REACT_APP_BUTTON_GRADIENT_COLOR,
    textColor: "#ffffff",
    middleTextColor: "#ffffff",
  },
];
const drawerItems = [
  {
    name: "My Details",
  },
  {
    name: "Family Details",
  },
  {
    name: "PAN Details",
  },

  {
    name: "Address",
  },
  {
    name: "Delete Account",
  },
];

const INVESTMENT_ITEMS = [
  {
    name: "Digital Gold/Silver",
    icon: "acru_gold",
  },
  {
    name: "Mutual Funds",
    icon: "mutual_fund",
  },
  {
    name: "Save Tax",
    icon: "save_tax",
  },
  {
    name: "Stocks",
    icon: "acru_stocks",
  },
  {
    name: "Insurance",
    icon: "insurance",
  },
];

const GIFTING_ITEMS = [
  {
    name: "Digital Gold/Silver",
    icon: "acru_gold",
  },
];

const HOME_BUTTON_ITEMS = [
  {
    id: 1,
    name: "Mutual Funds",
    icon: "mficon",
    screen: "MutualHomeScreen",
  },
  {
    id: 2,
    name: "Digital Gold",
    icon: "gicon",
    screen: "SelfInvest",
  },
  {
    id: 3,
    name: "Digital Silver",
    icon: "sicon",
    screen: "SelfInvest",
  },
  {
    id: 4,
    name: "Insurance (Coming Soon)",
    icon: "insurance",
    screen: "MutualHomeScreen",
  },
];
const HOME_SCROLL_TILES = [
  {
    id: 1,
    name: "Celebrate Akshaya Tritiya with gold coins",
    icon: "coins",
    bgColor: "#017CF1",
  },
  // {
  //   id:2,
  //   name: "Small + Regular Savings = Big Returns",
  //   subheading:'',
  //   icon: "bagmoney",
  //   bgColor:'#FFF0D2'
  // },
  // {
  //   id:3,
  //   name: "A penny saved is a penny earned",
  //   subheading:'',
  //   icon: "penny",
  //   bgColor:'#EBF5FF'
  // },
];
const HOME_BOX_TILES = [
  {
    id: 1,
    name: "Withdraw anytime",
    icon: "withdraw",
    subheading: "No hidden charges",
  },
  {
    id: 2,
    name: "Never forget to save",
    icon: "save",
    subheading: "Set reminders",
  },
];
const legalItems = [
  {
    name: "Terms & Conditions",
  },
  {
    name: "Privacy Policy",
  },
  {
    name: "Cancelation & Refund Policy",
  },
  {
    name: "Delete Account",
  },
];

const sideBarItems = [
  {
    name: "Bank Details",
    image: "bank",
    hasItems: false,
  },
  {
    name: "Transactions History",
    image: "transactions",
    hasItems: false,
  },
  // {
  //   name: "Notifications",
  //   image: "notificationMenuIcon",
  //   hasItems: false,
  // },
  {
    name: "Manage Nominees",
    image: "nominee-icon",
    hasItems: false,
  },
  {
    name: "Refer friends and family",
    image: "refer",
    hasItems: false,
  },

  {
    name: "Terms & Conditions",
    image: "terms",
    hasItems: false,
  },
  {
    name: "Privacy Policy",
    image: "privacy",
    hasItems: false,
  },
  {
    name: "Cancellation & Refund Policy",
    image: "cancel",
    hasItems: false,
  },

  {
    name: "About Acru",
    image: "menuACRUicon",
    hasItems: false,
  },
];

const BACKGROUND_GREDIENT_COLOR = [
  "#FFFFFF",
  "#FFFFFF",
  "#FFFFFF",
  "#FFFFFF",
  "#FFFFFF",
  "#FFFFFF",
  "#FFFFFF",
  "#FFFFFF",
  "#FFFFFF",
];

const MUTUAL_FUND_ITEMS = [
  {
    name: "Kotak Flexicap Fund",
    amu: "38294.75 Cr",
    isEquity: true,
    type: "Equity",
    isGrowth: true,
    equityType: "Flexi Cap",
    code: "KFF",
  },
  {
    name: "Axis Bluechip Fund",
    amu: "36890.65 Cr",
    isEquity: true,
    type: "Equity",
    isGrowth: true,
    equityType: "Large Cap",
    code: "ABF",
  },
  {
    name: "HDFC Mid-Cap Fund",
    amu: "36158.27 Cr",
    isEquity: true,
    type: "Equity",
    isGrowth: true,
    equityType: "Mid Cap",
    code: "HDFCMCF",
  },
  {
    name: "ICICI Prudential Bluechip Fund",
    amu: "35929.40 Cr",
    isEquity: true,
    type: "Equity",
    isGrowth: true,
    equityType: "Large Cap",
    code: "ICICIPBF",
  },
  {
    name: "SBI Blue Chip Fund",
    amu: "35616.67 Cr",
    isEquity: true,
    type: "Equity",
    isGrowth: true,
    equityType: "Large Cap",
    code: "SBIBCF",
  },
  {
    name: "Nippon India Small Cap Fund",
    amu: "23765.05 Cr",
    isEquity: true,
    type: "Equity",
    isGrowth: true,
    equityType: "Small Cap",
    code: "NISCF",
  },
];
const MUTUAL_FUND_TYPES = [
  {
    title: "NFO",
    detail: "New Fund Offers",
    icon: "https://acru-asset.s3.us-east-1.amazonaws.com/assets/nfo.svg",
    asset_sub_category: "Equity",
  },
  {
    title: "Invest with ₹100",
    minAmount: "100",
    type: "ALL",
    icon: "https://acru-asset.s3.us-east-1.amazonaws.com/assets/hundred.svg",
    asset_sub_category: "",
  },
  {
    title: "Save Tax",
    icon: "https://acru-asset.s3.us-east-1.amazonaws.com/assets/taxsaver.svg",
    asset_sub_category: "Tax Savings",
  },
  {
    title: "Return Oriented",
    icon: "https://acru-asset.s3.us-east-1.amazonaws.com/assets/returnoriented.svg",
    asset_sub_category: "Small Cap",
  },
  {
    title: "Large Cap",
    icon: "https://acru-asset.s3.us-east-1.amazonaws.com/assets/largecap.svg",
    asset_sub_category: "Large Cap",
  },
  {
    title: "Mid Cap",
    icon: "https://acru-asset.s3.us-east-1.amazonaws.com/assets/midcap.svg",
    asset_sub_category: "Mid Cap",
  },
  {
    title: "Small Cap",
    icon: "https://acru-asset.s3.us-east-1.amazonaws.com/assets/smallcap.svg",
    asset_sub_category: "Small Cap",
  },
  {
    title: "Equity",
    icon: "https://acru-asset.s3.us-east-1.amazonaws.com/assets/equity.svg",
    asset_sub_category: "Equity",
  },
  {
    title: "Liquid",
    icon: "https://acru-asset.s3.us-east-1.amazonaws.com/assets/liquid.svg",
    asset_sub_category: "",
    type: "Fixed Income",
  },
  {
    title: "Index",
    icon: "https://acru-asset.s3.us-east-1.amazonaws.com/assets/index.svg",
    asset_sub_category: "Index",
  },
];
const amcItems = [
  { id: "101", name: "Aditya Birla Sun Life Mutual Fund", selected: false },
  { id: "102", name: "Axis Mutual Fund", selected: false },
  { id: "103", name: "Baroda BNP Paribas Mutual Fund", selected: false },
  { id: "104", name: "Canara Robeco Mutual Fund", selected: false },
  { id: "105", name: "DSP Mutual Fund", selected: false },
  { id: "106", name: "Edelweiss Mutual Fund", selected: false },
  { id: "107", name: "Franklin Templeton Mutual Fund", selected: false },
  { id: "108", name: "HDFC Mutual Fund", selected: false },
  { id: "109", name: "HSBC Mutual Fund", selected: false },
  { id: "110", name: "ICICI Prudential Mutual Fund", selected: false },
  { id: "111", name: "IDFC Mutual Fund", selected: false },
  { id: "112", name: "Invesco Mutual Fund", selected: false },
  { id: "113", name: "Kotak Mahindra Mutual Fund", selected: false },
];
const catItems = [
  { id: "01", name: "All", selected: false },
  { id: "02", name: "Commodity", selected: false },
  { id: "03", name: "Equity", selected: false },
  { id: "04", name: "Fixed Income", selected: false },
  { id: "05", name: "Global", selected: false },
  { id: "06", name: "Hybrid", selected: false },
];
const ratingFilterItems = [
  { id: "301", name: "⭐️ ⭐️ ⭐️ ⭐️ ⭐️", selected: false },
  { id: "302", name: "⭐️ ⭐️ ⭐️ ⭐️", selected: false },
  { id: "303", name: "⭐️ ⭐️ ⭐️", selected: false },
  { id: "304", name: "⭐️ ⭐️", selected: false },
  { id: "305", name: "⭐️", selected: false },
];

const riskFilterItems = [
  { id: "401", name: "All Risks", selected: false, type: "ALL" },
  { id: "402", name: "Low Risk", selected: false, type: "LOW" },
  { id: "403", name: "Medium Risk", selected: false, type: "MEDIUM" },
  { id: "404", name: "High Risk", selected: false, type: "HIGH" },
];
const subCategoryFilterItems = [
  { title: "ALL", icon: "tax", asset_sub_category: "" },
  { title: "Tax Saving", icon: "tax", asset_sub_category: "Tax Savings" },
  {
    title: "High Returns",
    icon: "highreturn",
    asset_sub_category: "Small Cap",
  },
  { title: "Large Cap", icon: "largecap", asset_sub_category: "Large Cap" },
  { title: "Mid Cap", icon: "midcap", asset_sub_category: "Mid Cap" },
  { title: "Small Cap", icon: "smallcap", asset_sub_category: "Small Cap" },
];
const investFilterItems = [
  { id: "501", name: "SIP" },
  { id: "502", name: "ONE-TIME" },
];
const sortByFilterItems = [
  { id: "601", name: "100", selected: false },
  { id: "602", name: "500", selected: false },
  { id: "603", name: "1000", selected: false },
  { id: "604", name: "5000", selected: false },
  { id: "605", name: "10000", selected: false },
];

const minimumInvestmentItems = [
  { id: "601", name: "100", selected: false },
  { id: "602", name: "500", selected: false },
  { id: "603", name: "1000", selected: false },
  { id: "604", name: "5000", selected: false },
  { id: "605", name: "10000", selected: false },
];

const minimumInvestmentItemsWithHundred = [
  { id: "601", name: "100", selected: false },
];

const categoryFilterItems = [
  { id: "201", name: "Debt Schemes" },
  { id: "202", name: "Equity Schemes" },
  { id: "203", name: "Hybrid Schemes" },
  { id: "204", name: "Other Schemes" },
  { id: "205", name: "Solution Oriented Schemes" },
];
const CONTENT = [
  {
    isExpanded: false,
    id: "201",
    category_name: "Debt Schemes",
    subcategory: [
      { id: 1, val: "Banking and PSU" },
      { id: 2, val: "Coporate Bond" },
      { id: 3, val: "Credit Risk" },
    ],
  },
  {
    isExpanded: false,
    id: "202",
    category_name: "Equity Schemes",
    subcategory: [
      { id: 4, val: "Sub Cat 4" },
      { id: 5, val: "Sub Cat 5" },
    ],
  },
  {
    isExpanded: false,
    id: "203",
    category_name: "Hybrid Schemes",
    subcategory: [
      { id: 7, val: "Sub Cat 7" },
      { id: 9, val: "Sub Cat 9" },
    ],
  },
  {
    isExpanded: false,
    id: "204",
    category_name: "Other Scheme",
    subcategory: [
      { id: 10, val: "Sub Cat 10" },
      { id: 12, val: "Sub Cat 2" },
    ],
  },
  {
    isExpanded: false,
    id: "205",
    category_name: "Solution Oriented Schemes",
    subcategory: [
      { id: 13, val: "Sub Cat 13" },
      { id: 15, val: "Sub Cat 5" },
    ],
  },
];
const WEALTHS = [
  { KEY: "FOREX_DEALER", VALUE: "FOREX DEALER" },
  { KEY: "SELF_EMPLOYED", VALUE: "SELF EMPLOYED" },
  { KEY: "HOUSE_WIFE", VALUE: "HOUSEWIFE" },
  { KEY: "PUBLIC_SECTOR_SERVICE", VALUE: "PUBLIC SECTOR" },
  { KEY: "PRIVATE_SECTOR_SERVICE", VALUE: "PRIVATE SECTOR" },
  { KEY: "GOVERNMENT_SERVICE", VALUE: "GOVERNMENT SECTOR" },
];

const WEALTHLIST = [
  "SELF EMPLOYED",
  "SALARY",
  "BUSINESSMAN",
  "GIFT",
  "ANCESTRAL PROPERTY",
  "RENTAL INCOME",
  "PRIZE MONEY",
  "ROYALTY",
  "OTHERS",
];

const OCCUPATION_TYPES = [
  "AGRICULTURE",
  "BUSINESS",
  "DOCTOR",
  "FOREX DEALER",
  "PROFESSIONAL",
  "SELF EMPLOYED",
  "RETIRED",
  "HOUSEWIFE",
  "STUDENT",
  "PUBLIC SECTOR",
  "PRIVATE SECTOR",
  "GOVERNMENT SECTOR",
  "OTHERS",
];

const ACCOUNT_TYPES = ["SAVINGS", "CURRENT"];

const WEALTH_TYPE_LIST = [
  { key: "SELF EMPLOYED", value: "SELF_EMPLOYED" },
  { key: "SALARY", value: "SALARY" },
  { key: "BUSINESSMAN", value: "BUSINESS" },
  { key: "GIFT", value: "GIFT" },
  { key: "ANCESTRAL PROPERTY", value: "ancestral property" },
  { key: "RENTAL INCOME", value: "RENTAL_INCOME" },
  { key: "PRIZE MONEY", value: "PRIZE_MONEY" },
  { key: "ROYALTY", value: "ROYALTY" },
  { key: "OTHERS", value: "OTHERS" },
];

const OCCUPATION_PROOF_TYPE_LIST = [
  { key: "AGRICULTURE", value: "AGRICULTURE" },
  { key: "BUSINESS", value: "BUSINESS" },
  { key: "DOCTOR", value: "DOCTOR" },
  { key: "FOREX DEALER", value: "FOREX_DEALER" },
  { key: "PROFESSIONAL", value: "PROFESSIONAL" },
  { key: "SELF EMPLOYED", value: "SELF_EMPLOYED" },
  { key: "RETIRED", value: "RETIRED" },
  { key: "HOUSEWIFE", value: "HOUSE_WIFE" },
  { key: "STUDENT", value: "STUDENT" },
  { key: "PUBLIC SECTOR", value: "PUBLIC_SECTOR_SERVICE" },
  { key: "PRIVATE SECTOR", value: "PRIVATE_SECTOR_SERVICE" },
  { key: "GOVERNMENT SECTOR", value: "GOVERNMENT_SERVICE" },
  { key: "OTHERS", value: "OTHERS" },
];

const ADDRESS_PROOF_TYPE_LIST = [
  { key: "PASSPORT", value: "PASSPORT" },
  { key: "DRIVING LICENCE", value: "driving_licence" },
  { key: "VOTER ID", value: "VOTER_ID" },
];

const Tickets_Categories_Items = [
  { id: "201", name: "Installation/Crash" },
  { id: "202", name: "Login/Account issues" },
  { id: "203", name: "KYC issues" },
  { id: "204", name: "KYC Re-initiate" },
  { id: "205", name: "Fund Purchase issues" },
  { id: "206", name: "Fund Redemption issues" },
];

const FUNDS_CATEGORY_TILES = [
  {
    id: 1,
    name: "Global Funds",
    icon: "https://acru-asset.s3.us-east-1.amazonaws.com/assets/GlobalFund.svg",
    subheading:
      "Invest in global opportunities with our top-performing global funds",
    bgColor: "linear-gradient(180deg, #7474BF 0%, #348AC7 100%)",
    title: "Global",
    type: "Global",
    amc_code: "ALL",
    risk_profile: "ALL",
  },
  {
    id: 2,
    name: "Sector Specific Funds",
    subheading: "Explore sector-specific investments tailored to your goals",
    icon: "https://acru-asset.s3.us-east-1.amazonaws.com/assets/SectorFund.svg",
    title: "Sector Specific",
    bgColor: "linear-gradient(180deg, #24C6DC 0%, #514A9D 100%)",
    asset_sub_category:
      "Sector Specific - FMCG,Sector Specific - Banks & Financial Services,Sector Specific - Diversified,Sector Specific - Pharma,Sector Specific - Technology,Sector Specific - Transportation",
  },
  {
    id: 3,
    name: "Solution oriented Funds",
    subheading:
      "Explore our solution-oriented mutual funds to meet your long-term financial goals",
    icon: "https://acru-asset.s3.us-east-1.amazonaws.com/assets/SolutionFund.svg",
    bgColor: "linear-gradient(180deg, #00467F 0%, #249DFF 100%)",
    title: "Solution Oriented",
    asset_sub_category: "Solution Oriented - Retirement",
  },
  {
    id: 3,
    name: "Thematic Funds",
    subheading:
      "Capitalize on global trends with our thematic mutual fund range",
    icon: "https://acru-asset.s3.us-east-1.amazonaws.com/assets/ThematicFund.svg",
    bgColor: "linear-gradient(180deg, #314755 0%, #26A0DA 100%)",
    title: "Thematic",
    asset_sub_category:
      "Thematic - Business Cycles,Thematic - Commodities,Thematic - Consumption,Thematic - Contra,Thematic - Dividend Yield,Thematic - ESG,Thematic - Energy,Thematic - Infrastructure,Thematic - Innovation,Thematic - MNC,Thematic - Manfacturing,Thematic - PSU,Thematic - Quant,Thematic - Rural & Agriculture,Thematic - Service Industries,Thematic - Shariah",
  },
];

const DashboardCardData = [
  {
    id: 1,
    name: "Gold Coins",
    subheading: "Order gold coins online and enjoy doorstep delivery",
    icon: "https://acru-asset.s3.us-east-1.amazonaws.com/assets/bannerRight.svg",
    bgColor: "linear-gradient(286.2deg, #00B0FF 10.93%, #0487AA 77.81%)",
  },
  {
    id: 2,
    name: "Gifting",
    subheading:
      "Surprise your loved ones with the gift of digital gold and silver",
    icon: "https://acru-asset.s3.us-east-1.amazonaws.com/assets/GiftingDashboard.svg",
    bgColor: "linear-gradient(286.2deg, #71E8FC 10.93%, #FF84D5 77.81%)",
  },
  {
    id: 1,
    name: "Save Now Buy Later",
    subheading: "Set your goals and start saving for the future",
    icon: "https://acru-asset.s3.us-east-1.amazonaws.com/assets/arrow_home.svg",
    bgColor: "linear-gradient(180deg, #3690F0 0%, #86BEFA 100%)",
  },
];
const GOLD_SILVER_CATEGORY_TILES = [
  // will work in future
  {
    id: 1,
    name: "Gift Gold/Silver",
    icon: "https://acru-asset.s3.us-east-1.amazonaws.com/assets/giftCard.svg",
    subheading:
      "Surprise your loved ones with the gift of digital gold and silver",
    bgColor: "linear-gradient(180deg, #7474BF 0%, #348AC7 100%)",
  },
  {
    id: 2,
    name: "Redeem",
    subheading: "Convert your digital gold/silver to physical coins with ease",
    icon: "https://acru-asset.s3.us-east-1.amazonaws.com/assets/redeemCard.svg",
    bgColor: "linear-gradient(180deg, #24C6DC 0%, #514A9D 100%)",
  },
  {
    id: 3,
    name: "Sell",
    subheading: "Ready to cash out your gold/silver? We make it quick and easy",
    icon: "https://acru-asset.s3.us-east-1.amazonaws.com/assets/sellCard.svg",
    bgColor: "linear-gradient(180deg, #00467F 0%, #249DFF 100%)",
  },
  {
    id: 3,
    name: "Gold Coins",
    subheading: "Order gold coins online and enjoy doorstep delivery",
    icon: "https://acru-asset.s3.us-east-1.amazonaws.com/assets/coinsCard.svg",
    bgColor: "linear-gradient(180deg, #314755 0%, #26A0DA 100%)",
  },
];

const EVENT_TYPES = [
  {
    id: 1,
    title: "Just Born",
    icon: "https://acru-asset.s3.us-east-1.amazonaws.com/assets/child.svg",
    selectedicon:
      "https://acru-asset.s3.us-east-1.amazonaws.com/assets/selectedchild.svg",
  },
  {
    id: 1,
    title: "Birthday",
    icon: "https://acru-asset.s3.us-east-1.amazonaws.com/assets/cake.svg",
    selectedicon:
      "https://acru-asset.s3.us-east-1.amazonaws.com/assets/selectedcake.svg",
  },
  {
    id: 1,
    title: "Marriage",
    icon: "https://acru-asset.s3.us-east-1.amazonaws.com/assets/marriage.svg",
    selectedicon:
      "https://acru-asset.s3.us-east-1.amazonaws.com/assets/selectedmarrige.svg",
  },
  {
    id: 1,
    title: "Anniversary",
    icon: "https://acru-asset.s3.us-east-1.amazonaws.com/assets/anniversary.svg",
    selectedicon:
      "https://acru-asset.s3.us-east-1.amazonaws.com/assets/selectedanniversary.svg",
  },
  {
    id: 1,
    title: "Promotion",
    icon: "https://acru-asset.s3.us-east-1.amazonaws.com/assets/promotion.svg",
    selectedicon:
      "https://acru-asset.s3.us-east-1.amazonaws.com/assets/selectedpromotion.svg",
  },
  {
    id: 1,
    title: "Others",
    icon: "https://acru-asset.s3.us-east-1.amazonaws.com/assets/others.svg",
    selectedicon:
      "https://acru-asset.s3.us-east-1.amazonaws.com/assets/selectedother.svg",
  },
];
const DateList = [
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "10",
  "11",
  "12",
  "13",
  "14",
  "15",
  "16",
  "17",
  "18",
  "19",
  "20",
  "21",
  "22",
  "23",
  "24",
  "25",
  "26",
  "27",
  "28",
];

const GOAL_TYPES = [
  {
    id: 1,
    title: "Wedding",
    icon: "https://acru-asset.s3.us-east-1.amazonaws.com/assets/wedding.svg",
    heading: "Plan your dream weading with ease",
    amountHeading: "What is the budget for your wedding?",
    yearHeading: "When are you planning to get married?",
  },
  {
    id: 1,
    title: "Vacation",
    icon: "https://acru-asset.s3.us-east-1.amazonaws.com/assets/trip.svg",
    heading:
      "Invest in your dream destinations without worrying about the cost",
    amountHeading: "What is the budget for your travel plans?",
    yearHeading: "When do you planning to go on your trip?",
  },
  {
    id: 1,
    title: "Education",
    icon: "https://acru-asset.s3.us-east-1.amazonaws.com/assets/education.svg",
    heading: "Invest towards your child's education and secure their future",
    amountHeading: "What is your budget for education?",
    yearHeading: "When do you plan to start your education?",
  },
  {
    id: 1,
    title: "Shopping",
    icon: "https://acru-asset.s3.us-east-1.amazonaws.com/assets/shopping.svg",
    heading: "Invest in your shopping spree without breaking the bank",
    amountHeading: "What is your budget for shopping?",
    yearHeading: "When do you plan to shopping?",
  },
  {
    id: 1,
    title: "Vehicle",
    icon: "https://acru-asset.s3.us-east-1.amazonaws.com/assets/vehicle.svg",
    heading: "Invest in your journey with your dream vehicle",
    amountHeading: "What is the budget for purchasing a vehicle?",
    yearHeading: "When are you planning to purchase a vehicle?",
  },
  {
    id: 1,
    title: "Home",
    icon: "https://acru-asset.s3.us-east-1.amazonaws.com/assets/home.svg",
    heading: "Take the first step towards your home ownership dream with us",
    amountHeading: "What is the budget for purchasing a home?",
    yearHeading: "When are you planning to purchase your dream home?",
  },

  {
    id: 1,
    title: "Retirement",
    icon: "https://acru-asset.s3.us-east-1.amazonaws.com/assets/retirement.svg",
    heading: "Secure your retirement with our diverse investment options.",
    amountHeading: "What is your retirement savings goal?",
    yearHeading: "In which year do you plan to retire?",
  },
  {
    id: 1,
    title: "Custom goal",
    icon: "https://acru-asset.s3.us-east-1.amazonaws.com/assets/customGoal.svg",
    heading: "Invest in your financial dreams and create a brighter future",
    amountHeading: "What is your goal amount?",
    yearHeading: "In which year do you plan to complete your goal?",
  },
];
const MUTUAL_DISCLAIMER =
  "Indicative investment calculations provided are not financial advice and may not accurately reflect actual performance, which can be affected by market conditions and other uncontrollable factors.";
const GOLD_DISCLAIMER =
  "Gold has delivered an average annual return of 10.9% over the last 10 years";
const SILVER_DISCLAIMER =
  "Silver's average annual return has been 3.7% over the past decade.";
const INSTRUMENT_TYPES = [
  {
    id: 1,
    name: "Mutual Funds",
    image:
      "https://acru-asset.s3.us-east-1.amazonaws.com/assets/mf.svg",
  },
  {
    id: 2,
    name: "Digital Gold",
    image:
      "https://acru-asset.s3.us-east-1.amazonaws.com/assets/gold.svg",
  },
  {
    id: 3,
    name: "Digital Silver",
    image:
      "https://acru-asset.s3.us-east-1.amazonaws.com/assets/silver.svg",
  },
];
const RELATION_LIST = [
  "Father",
  "Mother",
  "Brother",
  "Sister",
  "Spouse",
  "Children",
];

export {
  RELATION_LIST,
  FUNDS_CATEGORY_TILES,
  Constants,
  Messages,
  BACKGROUND_GREDIENT_COLOR,
  INVESTMENT_ITEMS,
  drawerItems,
  spalshItems,
  legalItems,
  sideBarItems,
  ButtonTitles,
  Links,
  MUTUAL_FUND_ITEMS,
  amcItems,
  ratingFilterItems,
  riskFilterItems,
  subCategoryFilterItems,
  investFilterItems,
  sortByFilterItems,
  categoryFilterItems,
  minimumInvestmentItems,
  minimumInvestmentItemsWithHundred,
  CONTENT,
  WEALTHS,
  OCCUPATION_TYPES,
  ADDRESS_PROOF_TYPE_LIST,
  WEALTHLIST,
  OCCUPATION_PROOF_TYPE_LIST,
  WEALTH_TYPE_LIST,
  ACCOUNT_TYPES,
  HOME_BUTTON_ITEMS,
  HOME_SCROLL_TILES,
  HOME_BOX_TILES,
  GIFTING_ITEMS,
  Tickets_Categories_Items,
  MUTUAL_FUND_TYPES,
  GOLD_SILVER_CATEGORY_TILES,
  EVENT_TYPES,
  dashboardCoursalItems,
  catItems,
  DashboardCardData,
  GOAL_TYPES,
  INSTRUMENT_TYPES,
  MUTUAL_DISCLAIMER,
  GOLD_DISCLAIMER,
  SILVER_DISCLAIMER,
  DateList,
};
